import React, { useEffect, useState } from 'react';
import Typography from '../components/v2/Typography';
import Button from '../components/v2/Button';
import { Download, ArrowRight, Search, Menu, SearchIcon, Globe, InfoIcon, CheckIcon } from 'lucide-react';
import DomainCard from '../components/v2/DomainCard';
import IButton from '../components/v2/IButton';
import Input from '../components/v2/Input';
import Textarea from '../components/v2/TextArea';
import { Link } from 'react-router-dom';
import Faq, { faqData } from '../atoms/Faq';
import useApp from '../hooks/useApp';

const BlogSection = ({display = 'both'}) => {

  const { blogsList } = useApp();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const showBlog = display === 'both' || display === 'onlyBlog';
  const showNewsletter = display === 'both' || display === 'onlyNewsletter';

  useEffect(() => {
    if (error) {
      setTimeout(() => setError(''), 5000);
    }
    if (success) {
      setTimeout(() => setSuccess(''), 5000);
    }
  }, [error, success]);

  const handleSubscribe = () => {
    const email = document.getElementById('ns_email').value;

    if (!email) {
      alert('Please enter your email');
      return;
    }

    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(email)) {
      alert('Please enter a valid email address');
      return;
    }


    try {
      setLoading(true);
      fetch(`https://api.webstadia.com/v1/newsletter/682bb02ae26a621dc5bcd2ca`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email }),
      });
      setLoading(false);
      setSuccess('You have successfully subscribed to our newsletter');
    } catch (error) {
      console.log(error);
      setLoading(false);
      setError('Something went wrong');
    }
  }

  return (
  
    <div className="blogs-wrapper" style={display === 'onlyNewsletter' ? {
      background: "transparent"
    } : {}}>
    <div className="inner" style={display === 'onlyNewsletter' ? {
      maxWidth: "100%",
      width: "100%"
    } : {}}>
      {showBlog && <div className="blogs-heading">
        <Typography variant="h1">Blogs</Typography>
      </div>}
      <div className="blogs-content">
        {showBlog && <div className="blogs-col">
          
          {blogsList.map((blog) => (
              <div key={blog.link} className='blog-card'>
              <div className="blog-img">
                <img src={blog["image"]} alt="" srcset="" />
              </div>
              <div className="blog-text">
                <div className="blog-title">
                  <Typography variant="para">{blog["title"]}</Typography>
                </div>
                <div className="blog-desc">
                  <Typography variant="para">{blog["description"]}</Typography>
                </div>
                <div className="blog-button">
                  <Button onClick={() => window.open(blog.link, '_blank')} variant="secondary-2" size='sm' rightIcon={ArrowRight}>
                  <Typography variant={'button'}>Read more</Typography>
                  </Button>
                </div>
              </div>
            </div>
          ))}

        </div>}
        {showNewsletter && <div className="blogs-col">
          <div className="blog-newscard">
            <div className="inner">
              <div className="col">
                <Typography variant="para">Subscribe to our #1 Newsletter, we keep you updated and provides helpful tips over it.</Typography>
              </div>
              <div className="col">
                <div className="email-wrapper">
                  <input id="ns_email" type="email" placeholder="Your email" />
                  <button onClick={handleSubscribe} disabled={loading}>
                    {loading ? (
                      <span>Subscribing...</span>
                    ) : (
                      <Typography variant="button">Sign Up</Typography>
                    )}
                  </button>
                </div>
                {error && <p className="error">{error}</p>}
                {success && <p className="success">{success}</p>}
              </div>
            </div>
          </div>
        </div>}
      </div>
    </div>
  </div>
  );
  }

  
  export default BlogSection;